/**
 * @file useAgentTextActions.js
 * @description useAgentTextActions hook for managing agent text actions.
 * @component useAgentTextActions
 * @exports useAgentTextActions - Main hook for managing agent text actions.
 */

import { useState } from "react";
import {
  TEXT_ERRORS,
  TEXT_SUCCUSS,
} from "../../../common/constants/agentModule/textConstants";
import {
  assignUsers,
  endTextConversation,
} from "../../../services/agentModule/text/text-conversation";
import { set } from "date-fns";

export function useAgentTextActions() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [openSendText, setOpenSendText] = useState(false);
  const [openSendEmail, setOpenSendEmail] = useState(false);

  const handleAssignClick = async (customerId, newAssignee) => {
    setLoading(true);
    setSuccess("");
    setError("");
    try {
      await assignUsers(customerId, newAssignee);
      setSuccess(TEXT_SUCCUSS.ASSIGNEE_UPDATE);
      return { success: true, message: TEXT_SUCCUSS.ASSIGNEE_UPDATE };
    } catch (err) {
      setError(TEXT_ERRORS.UPDATE_ASSIGNEE_ERROR);
      return { success: false, message: TEXT_ERRORS.UPDATE_ASSIGNEE_ERROR };
    } finally {
      setLoading(false);
    }
  };

  const handleEndConversationClick = async (customerId) => {
    setLoading(true);
    setSuccess("");
    setError("");
    try {
      await endTextConversation(customerId);
      setSuccess(TEXT_SUCCUSS.END_CONVERSATION);
      return { success: true, message: TEXT_SUCCUSS.END_CONVERSATION };
    } catch (err) {
      setError(TEXT_ERRORS.END_CONVERSATION_ERROR);
      return { success: false, message: TEXT_ERRORS.END_CONVERSATION_ERROR };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    success,
    error,

    handleAssignClick,
    handleEndConversationClick,
  };
}
